import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BodyListResponse } from 'src/app/core/models/general/body-list-response';
import { BodyResponse } from 'src/app/core/models/general/body-response';
import { ProyectoParticipantesDTO, RegistroHorasTutoriasPeriodoAcademicoDTO } from 'src/app/core/models/vinculacion/vinculacion-Interfaces';
import { environment } from 'src/environments/environment';

const API_URL = environment.apiUrlVinculacion;

@Injectable()
export class RegistroHorasTutoriasPeriodoAcademicoService {
  header = new Headers({ 'Content-Type': 'application/json' });

  constructor(private http: HttpClient) { }

  getRegistroHorasTutoriasPeriodoAcademicoService(): Observable<BodyListResponse<RegistroHorasTutoriasPeriodoAcademicoDTO>> {
    return this.http.get<BodyListResponse<RegistroHorasTutoriasPeriodoAcademicoDTO>>(API_URL + '/api/v1/registroHorasTutoriasPeriodoAcademico/todos');
  }

  guardarRegistroHorasTutoriasPeriodoAcademicoService(registroHorasTutoriasPeriodoAcademicoDTO: RegistroHorasTutoriasPeriodoAcademicoDTO): Observable<BodyResponse<RegistroHorasTutoriasPeriodoAcademicoDTO>> {
    return this.http.post<any>(API_URL + '/api/v1/registroHorasTutoriasPeriodoAcademico', registroHorasTutoriasPeriodoAcademicoDTO);
  }

  getRegistroHorasTutoriasPeriodoAcademicoPorCodigoService(codigo: string): Observable<BodyResponse<RegistroHorasTutoriasPeriodoAcademicoDTO>> {
    return this.http.get<BodyResponse<RegistroHorasTutoriasPeriodoAcademicoDTO>>(API_URL + '/api/v1/registroHorasTutoriasPeriodoAcademico/' + codigo);
  }

  getRegistroHorasTutoriasPeriodoAcademicoPorCodigoParticipanteEstudiante(codigoParticipante: any): Observable<BodyListResponse<RegistroHorasTutoriasPeriodoAcademicoDTO>> {
    return this.http.get<BodyListResponse<RegistroHorasTutoriasPeriodoAcademicoDTO>>(API_URL + '/api/v1/registroHorasTutoriasPeriodoAcademico/horasTutoriasEstudiants/' + Number(codigoParticipante));
  }
  //@GetMapping({ "/validacion/horasTutoria/{codigoParticipante}/{anio}/{periodo}/{sesion}" })

  getValidarHorasTutoriasPorPeriodoAcademico(codigoParticipante: any, periodoAcademico: string, numeroHoras: string, proyectoParticipante: ProyectoParticipantesDTO, codigoRegistroHoras: string): Observable<BodyResponse<any>> {
    return this.http.post<BodyResponse<any>>(API_URL + '/api/v1/registroHorasTutoriasPeriodoAcademico/validacion/horasTutoria/' + codigoParticipante + '/' + periodoAcademico + '/' + numeroHoras + '/' + codigoRegistroHoras, proyectoParticipante);
  }

  getHorasTutoriasPorNumeroIdentificacionTutor(codigoParticipante: any): Observable<BodyListResponse<RegistroHorasTutoriasPeriodoAcademicoDTO>> {
    return this.http.get<BodyListResponse<RegistroHorasTutoriasPeriodoAcademicoDTO>>(API_URL + '/api/v1/registroHorasTutoriasPeriodoAcademico/consultarHorasTutoriasPorTutorIdentificador/' + codigoParticipante);
  }

  getHorasTutoriasPorProyectoPorParticipante(codigoProyecto: string, codigoParticipante: string): Observable<BodyListResponse<RegistroHorasTutoriasPeriodoAcademicoDTO>> {
    return this.http.get<BodyListResponse<RegistroHorasTutoriasPeriodoAcademicoDTO>>(API_URL + '/api/v1/registroHorasTutoriasPeriodoAcademico/horasTutoriasPorProyecto/' + codigoProyecto + '/' + codigoParticipante);
  }

  getRegistroHorasTutoriasPorTutor(codigoParticipanteTutor: any): Observable<BodyListResponse<RegistroHorasTutoriasPeriodoAcademicoDTO>> {
    return this.http.get<BodyListResponse<RegistroHorasTutoriasPeriodoAcademicoDTO>>(API_URL + '/api/v1/registroHorasTutoriasPeriodoAcademico/horasTutoriasTutor/' + Number(codigoParticipanteTutor));
  }
}
